import React from 'react';
import { BLOCK_LIBRARY } from './blockDefs';

// Left sidebar. Clicking a block inserts a new section containing it (after the
// current selection). Self-contained business blocks always become new sections.
export default function BlockLibrary({ onAdd }) {
  return (
    <div className="p-3 space-y-4" data-testid="block-library">
      <p className="text-[11px] text-gray-500 leading-snug px-1">Click a block to add it to the page. Then drag to reposition, or edit it on the right.</p>
      {BLOCK_LIBRARY.map((grp) => (
        <div key={grp.group}>
          <div className="text-[10px] uppercase tracking-widest text-gray-500 mb-2 px-1">{grp.group}</div>
          <div className="grid grid-cols-2 gap-2">
            {grp.items.map(({ type, label, icon: Icon }) => (
              <button key={type} type="button" data-testid={`lib-add-${type}`} onClick={() => onAdd(type)}
                className="flex flex-col items-center gap-1.5 rounded-md border border-slate-700 bg-slate-800/60 hover:border-red-500 hover:bg-slate-800 text-gray-300 py-3 transition-all">
                <Icon className="w-5 h-5" />
                <span className="text-[11px]">{label}</span>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
